<section class="sports-explorer-section py-5" *ngIf="sportsList && sportsList.length > 0">
  <div class="container-fluid px-4 py-5 px-md-5">
    <!-- Header Row -->
    <div class="row align-items-center mb-5">
      <div class="col-12 col-lg-8">
        <h2 class="text-white hf f80 text-uppercase fw-bold lh-sm mb-4 mb-lg-0 card-heading">
          THE BRAVE MAY NOT LIVE FOREVER,<br class="d-none d-md-block" />
          BUT THE CAUTIOUS DO NOT LIVE AT ALL.
        </h2>
      </div>
      <div class="col-12 col-lg-4 ps-lg-5">
        <div class="d-flex flex-column align-items-start">
          <p class="text-white f16 mb-4 max-w-lg-text">
            Every discipline on XDGE demands real commitment. Explore the sports, find your element, and start tracking what you've actually done. See
            your name climb the leaderboard as you try new sports.
          </p>
          <button class="hero-btn red text-uppercase f16" (click)="onViewAllClick($event)">EXPLORE ALL SPORTS</button>
        </div>
      </div>
    </div>

    <!-- Interactive Accordion Row -->
    <div class="row" *ngIf="!loading">
      <div class="col-12">
        <div class="sports-accordion">
          <div
            *ngFor="let sport of sportsList; let i = index"
            class="sport-card"
            [class.active]="activeId === sport.id"
            (mouseenter)="setActive(sport.id)"
          >
            <!-- Background Image -->
            <div class="card-bg-img" [style.background-image]="'url(' + fileDirectoriesPath + (sport.largeImage || sport.image) + ')'"></div>
            <div class="card-overlay"></div>

            <!-- Collapsed Content -->
            <div class="collapsed-content" *ngIf="activeId !== sport.id">
              <span class="collapsed-title hf f40 text-white text-uppercase">
                {{ sport.name }}
              </span>
            </div>

            <!-- Expanded Content -->
            <div class="expanded-content p-4 p-md-5" *ngIf="activeId === sport.id">
              <div class="active-info d-flex flex-column justify-content-end h-100">
                <div class="row align-items-end">
                  <div class="col-12 col-lg-8">
                    <h3 class="text-white hf f40 text-uppercase mb-2 active-sport-name">{{ sport.name }}</h3>
                    <p class="text-white f16 mb-0 active-sport-about">
                      {{ cleanHtml(sport.about) }}
                    </p>
                  </div>
                  <div class="col-12 col-lg-4 text-start text-lg-end mt-3 mt-lg-0">
                    <button class="hero-btn primary text-uppercase f16" (click)="onSportClick(sport, $event)">EXPLORE MORE</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
